/**
 * As of 1 Oct 2025, we will completely stop showing ads where the user has
 * selected "do not consent" and GDPR applies. This utility is used to tweak
 * parts of the site based on that setting.
 */
export function isGdprHideAdsActive() {
	return !!localStorage.getItem('GDPR_DNC_HIDE_ADS')
}
